import Logo from "assets/img/svg/navbar/logo";
import LogoIcon from "assets/img/svg/navbar/logoIcon";

interface NavigationHeaderProps {
    /** Whether the navigation is collapsed */
    isCollapsed?: boolean;
}

/**
 * Navigation header component displaying the Crealo logo
 * Text fades out smoothly, icon swaps with visibility
 */
const NavigationHeader = ({ isCollapsed = false }: NavigationHeaderProps) => {
    return (
        <div className="navigation-header">
            {/* Full logo - text fades out when collapsed */}
            <div
                className="navigation-header__logo-full"
                style={{
                    visibility: isCollapsed ? "hidden" : "visible",
                    // Delay hiding until text has faded
                    transitionDelay: isCollapsed ? "0.25s" : "0s",
                }}
            >
                <Logo showText={!isCollapsed} />
            </div>

            {/* Icon only - visible when collapsed, positioned exactly over the icon part */}
            <div
                className="navigation-header__logo-icon"
                style={{
                    visibility: isCollapsed ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    // Delay showing until text has faded
                    transitionDelay: isCollapsed ? "0.15s" : "0s",
                }}
            >
                <LogoIcon />
            </div>
        </div>
    );
};

export default NavigationHeader;
